import { captureMiddlewareError } from './captureMiddlewareError'
import { createApiResponseError } from '../default/ApiResponseError'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Verifies a phone number
 * @returns {Promise<GetLocResponse>}
 */
export async function getLoc() {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/ip-location'
  const url = `${apiBase}${endpoint}`
  const CAPTURE_ID = `getLoc@${url}`

  try {
    const response = await fetch(url, {
      headers: getMiddlewareHeaders(),
      method: 'GET',
    })

    if (response.ok) {
      const data = await response.json()
      return data || {}
    }

    throw await createApiResponseError(response, endpoint)
  } catch (error) {
    captureMiddlewareError(CAPTURE_ID, /** @type {Error} */ (error), false)
    return {}
  }
}
